module.exports = __webpack_public_path__ + "static/media/bluecat2.705f2900.png";